import { memo } from 'react';
import { Sidebar } from 'react-feather';
import { css } from '@emotion/react';
import { Tooltip } from '@trinity/chat-components/components/presentation/Tooltip';
import { useTheme, Constants } from '@trinity/chat-components/components/Theme';
import type { Theme as LocalTheme } from '@trinity/chat-components/types/theme';

type Props = {
  className?: string;
  onClick: () => void;
  open: boolean;
};

export const SidebarToggler = memo(({ className, onClick, open }: Props) => {
  const theme = useTheme();

  const tooltipTitle = open ? 'Close' : 'Expand';

  return (
    <Tooltip title={tooltipTitle}>
      <div
        css={open ? rootOpenedCss(theme) : rootCollapsedCss(theme)}
        className={className}
        onClick={onClick}
      >
        <Sidebar size={28} css={iconCss(theme)} />
      </div>
    </Tooltip>
  );
});

const rootBaseCss = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  width: Constants.Sidebar.IconSize,
  height: Constants.Sidebar.IconSize,
  boxSizing: 'border-box',

  padding: 5,

  borderRadius: '50%',
  cursor: 'pointer',
});

const rootCollapsedCss = (theme: LocalTheme.Theme) =>
  css([
    rootBaseCss,
    {
      backgroundColor: theme.palette.btnPrimary.bg,

      '&:hover': {
        backgroundColor: theme.palette.btnPrimary.active.bg,
      },
    },
  ]);

const rootOpenedCss = (theme: LocalTheme.Theme) =>
  css([
    rootBaseCss,
    {
      backgroundColor: theme.palette.btnPrimary.active.bg,
    },
  ]);

const iconCss = (theme: LocalTheme.Theme) =>
  css({
    color: theme.palette.btnPrimary.color,
  });
